import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService as RoleGuard } from './Common/auth-guard.service';
import { APP_BASE_HREF } from '@angular/common';
import { SidebarComponent } from '../app/inside-of-application/sidebar/sidebar.component';
import { DashboardComponent } from '../app/inside-of-application/dashboard/dashboard.component';
import { BadRequestComponent } from '../app/out-of-application/bad-request/bad-request.component';
import { PageNotFoundComponent } from '../app/out-of-application/page-not-found/page-not-found.component';
import { LogoutComponent } from '../app/out-of-application/logout/logout.component';
import { UnAuthorizeComponent } from '../app/out-of-application/un-authorize/un-authorize.component';
import { SessionExpiredComponent } from './out-of-application/session-expired/session-expired.component';
import { LoginComponent } from './out-of-application/login/login.component';
import { HomeComponent } from './inside-of-application/home/home.component';
import { CreateServiceRequestComponent } from './inside-of-application/create-service-request/create-service-request.component';
import { ServiceRequestComponent } from './inside-of-application/service-request/service-request.component';
import { CategoryMasterComponent } from './inside-of-application/category-master/category-master.component';
import { SubCategoryComponent } from './inside-of-application/sub-category/sub-category.component';
import { ViewServiceRequestComponent } from './inside-of-application/Views/view-service-request/view-service-request.component';
import { ViewmyservicerequestComponent } from './inside-of-application/Views/viewmyservicerequest/viewmyservicerequest.component';
import { SearchViewComponent } from './out-of-application/search-view/search-view.component';
import { MyServiceRequestComponent } from './inside-of-application/my-service-request/my-service-request.component';
// import {ItemMasterComponent } from './inside-of-application/item-master/item-master.component';
import { ItemMasterComponent } from './inside-of-application/item-master/item-master.component';
import { AssigmentGroupComponent } from './inside-of-application/assigment-group/assigment-group.component';
import { MappingGroupItemComponent } from './inside-of-application/mapping-group-item/mapping-group-item.component';
import { EscalationSequenceComponent } from './inside-of-application/escalation-sequence/escalation-sequence.component';
import { AdminBarChartComponent } from './inside-of-application/admin-bar-chart/admin-bar-chart.component';
import { CompleteReportComponent } from './inside-of-application/Reports/complete-report/complete-report.component';
const routes: Routes = [

    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'login', component: LoginComponent },
    { path: 'ref/:Path', component: LoginComponent },
    { path: 'logout', component: LogoutComponent },
    { path: 'home', component: HomeComponent },
    { path: 'unauthorize', component: UnAuthorizeComponent },
    { path: 'badrequest', component: BadRequestComponent },
    { path: 'pagenotfound', component: PageNotFoundComponent },
    { path: 'sessionexpired', component: SessionExpiredComponent },
    {
        path: 'error/:ID',
        component: PageNotFoundComponent
    },
    {
        path: '', component: HomeComponent,
        children: [
            {
                path: '',
                component: DashboardComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['User']
                }
            },
            {
                path: 'dashboard',
                component: DashboardComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['User']
                },
            },
            {
                path: 'CreateSr',
                component: CreateServiceRequestComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['User']
                }
            },
            {
                path: 'MyServiceRequest/:ID',
                component: MyServiceRequestComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['User']
                }

            },
            {
                path: 'ServiceRequest',
                component: ServiceRequestComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['GroupTeam', 'CategoryRole', 'Admin']
                }
            },
            {
                path: 'ServiceRequest/:ID',
                component: ServiceRequestComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['GroupTeam', 'CategoryRole', 'Admin']
                }

            },

            {
                path: 'ViewMyServiceRequest/:ID',
                component: ViewmyservicerequestComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['User']
                }
            },
            {
                path: 'categoryMaster',
                component: CategoryMasterComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['Admin']
                }
            },
            {
                path: 'SubCategory',
                component: SubCategoryComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['CategoryRole', 'Admin']
                }
            },

            {
                path: 'ViewSR/:ID',
                component: ViewServiceRequestComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['GroupTeam', 'CategoryRole', 'Admin']
                }
            },
            {
                path: 'MyHistoryView/:ID',
                component: ViewServiceRequestComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['GroupTeam', 'CategoryRole', 'Admin']
                }
            },
            {
                path: 'AllViewSR/:ID',
                component: ViewServiceRequestComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['GroupTeam', 'CategoryRole', 'Admin']
                }
            },
            {
                path: 'AssignedViewSR/:ID',
                component: ViewServiceRequestComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['GroupTeam', 'CategoryRole', 'Admin']
                }
            },
            {
                path: 'OpenViewSR/:ID',
                component: ViewServiceRequestComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['GroupTeam', 'CategoryRole', 'Admin']
                }
            },
            {
                path: 'AwViewSR/:ID',
                component: ViewServiceRequestComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['GroupTeam', 'CategoryRole', 'Admin']
                }
            },
            {
                path: 'CanViewSR/:ID',
                component: ViewServiceRequestComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['GroupTeam', 'CategoryRole', 'Admin']
                }
            },
            {
                path: 'MyGroupSR/:ID',
                component: ViewServiceRequestComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['GroupTeam', 'CategoryRole', 'Admin']
                }
            },

            {
                path: 'itemMaster',
                component: ItemMasterComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['CategoryRole', 'Admin']
                }
            },
            {
                path: 'AssignmentGroup',
                component: AssigmentGroupComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['CategoryRole', 'Admin']
                }
            },
            {
                path: 'MappingGroupItem',
                component: MappingGroupItemComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['CategoryRole', 'Admin']
                }
            },
            {
                path: 'EscalationSequence',
                component: EscalationSequenceComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['CategoryRole', 'Admin']
                }
            },
            {
                path: 'AdminBarChart',
                component: AdminBarChartComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['CategoryRole', 'Admin']
                }
            },
            {
                path: 'SLA/:ID',
                component: CompleteReportComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['User']
                }
            },
            {
                path: 'Aging/:ID',
                component: CompleteReportComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['User']
                }
            },
            {
                path: 'Status/:ID',
                component: CompleteReportComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['User']
                }
            },
            {
                path: 'Detailed/:ID',
                component: CompleteReportComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['User']
                }
            },
            {
                path: 'Final/:ID',
                component: CompleteReportComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['User']
                }
            },
        ]
    },
    {
        path: 'logout', component: LogoutComponent
    },
    { path: '**', redirectTo: 'pagenotfound' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule],
    //providers: [{ provide: APP_BASE_HREF, useValue: '/' }, RoleGuard]
})

export class AppRoutingModule {
}
